export const setEcomOrders = (state, orders) => {
    state.ecomOrders = orders;
};

export const addEcomOrder = (state, order) => {
    state.ecomOrders.data = [order, ...state.ecomOrders.data];
};

export const updateEcomOrder = (state, order) => {
    const orderIdx = state.ecomOrders.data.findIndex(_order => _order.id === order.id);
    if (orderIdx < 0) return;
    state.ecomOrders.data[orderIdx] = order;
};

export const setEcomCarts = (state, carts) => {
    state.ecomCarts = carts;
};

export const setWishlistItems = (state, items) => {
    state.wishlistItems = items;
};

const EcommerceMutation = {
    setEcomOrders,
    addEcomOrder,
    updateEcomOrder,
    setEcomCarts,
    setWishlistItems,
};

export default EcommerceMutation;
